import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import OfficialMediaModalStore from './store';

const styles = require('./index.less');

/**
 * 弹窗模板, 可以快速套用修改
 */
const OfficialMediaModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.officialMediaModalRoot)}>
        <div className="official-media-modal-root">
          <div className="official-media-modal-group-1" data-name="二维码弹窗">
            <div className="official-media-modal-layer-1">
              <img src={require(`./images/${store.communityType}.png`)} alt={store.communityType} />
            </div>
            <Link
              className="official-media-modal-layer-4"
              onClick={() => {
                store.onClickClose();
                onClose();
              }}
            />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(OfficialMediaModal, OfficialMediaModalStore);
